import React from "react";
import { Helmet } from "react-helmet";
import {
  BreadcrumbsWrap,
  BreadcrumbLink,
  BreadcrumbsBase,
} from "./breadcrumbs.styled";
import { BreadcrumbList } from "schema-dts";
import { helmetJsonLdProp } from "react-schemaorg";
import { baseDomain } from "../../utils/constants";

export interface BreadCrumbProps {
  name: string;
  url: string;
}

const Breadcrumbs = (props: { breadcrumbs: BreadCrumbProps[] }) => {
  const { breadcrumbs } = props;
  return (
    <BreadcrumbsBase>
      <BreadcrumbsWrap>
        {breadcrumbs.length > 1 &&
          breadcrumbs.map((node, index) => (
            <span key={index}>
              {(breadcrumbs.length != index + 1 && ( // Use link on all breadcrumbs but the last
                <BreadcrumbLink to={node.url}>{node.name}</BreadcrumbLink>
              )) || <span>{node.name}</span>}
            </span>
          ))}
      </BreadcrumbsWrap>
      {breadcrumbs.length > 1 && (
        <Helmet
          script={[
            helmetJsonLdProp<BreadcrumbList>({
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              itemListElement: breadcrumbs.map((node, index) => ({
                "@type": "ListItem",
                position: index + 1,
                name: node.name,
                item: `https://www.${baseDomain}${node.url}`,
              })),
            }),
          ]}
        />
      )}
    </BreadcrumbsBase>
  );
};

export default Breadcrumbs;
